import { logOut } from '../common/auth/Auth';
const { REACT_APP_TIMELIVE_API_URL_INTEGRATION, NODE_ENV, REACT_APP_TIMELIVE_ACCESS_TOKEN } = process.env;
const fetchIntegrationAPI = async (url: string, method: string, body?: any, includeHeader: boolean = true, accessToken: string = '', isAttachment: boolean = false) => {
    let finalBody = null;
    if (body !== "") {
        // finalBody = JSON.stringify(body);
        finalBody = isAttachment ? body : JSON.stringify(body);
    }
    let base_url = window.origin + '/integration/';
    
    if (NODE_ENV === 'development') {
        base_url = REACT_APP_TIMELIVE_API_URL_INTEGRATION as string;
        accessToken = REACT_APP_TIMELIVE_ACCESS_TOKEN as string;
    }

    let headersText = {};
    if (includeHeader) {
        isAttachment ?
            headersText = {
                //'Content-Type': 'multipart/form-data',
                //'AccessToken': NODE_ENV === 'development' ? accessToken : localStorage.getItem('accessToken')
                'AccessToken': localStorage.getItem('accessToken')
            } :
            headersText = {
                'Content-Type': 'application/json',
                //Open with out Login
                //'AccessToken': NODE_ENV === 'development' ? accessToken : localStorage.getItem('accessToken')
                //Open with Login
                'AccessToken': localStorage.getItem('accessToken')
            }
    }
    let init: RequestInit = {
        method: method,
        headers: headersText,
        body: finalBody,
        mode: 'cors',
    };
    if (url.includes("react.svc")) {
        init = {
            method: method,
            mode: 'cors',
            headers: headersText,
            body: finalBody
        };
    }
    if (NODE_ENV === 'production') {
        init = {
            method: method,
            headers: headersText,
            body: finalBody
        };
    }
    try {
        const response = await fetch(base_url + url, init)

        if (!response.ok) {
            if (response.status === 401) {               
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = `${window.origin}`;
                // Handle 401 Unauthorized (e.g., redirect to login page)
                throw new Error('Unauthorized - ' + response.status);
            } else {
                // Handle other HTTP errors (e.g., 404 Not Found)
                //throw new Error('HTTP Error ' + response.status);
            }
        }
        return response;
    }
    catch (error) {
        // console.error('Error fetching data:', error);
        throw error; // Propagate the error to the caller
    }

}

// export const useFetchAPI = async (url: string, method: string, body?: any, includeHeader: boolean = true) => {
//     const { accessToken } = useAppSelector((state) => state.timesheet);
//     let headersText = {};
//     if (includeHeader) {
//         headersText = {
//             'Content-Type': 'application/json',
//             "accesstoken": accessToken
//         }
//     }
//     const response = await fetch(base_url + url, {
//         method: method,
//         headers: headersText,
//         body: JSON.stringify(body)
//     })
//     return response;
// }

export default fetchIntegrationAPI;
//Open With Login
const toBase64 = (str: string) => {
    return window.btoa(unescape(encodeURIComponent(str)));
};